import {Model} from '@vuex-orm/core';
import UnitPlan from '@/store/units/UnitPlan';
import {IPreLearnings} from '@/interfaces/planner/purpose/IPreLearnings';

// @ts-ignore
export default class PreLearnings extends Model implements IPreLearnings {
    public static entity = 'unitplan_prelearnings';

    public static fields() {
        return {
            id: this.number(0),
            idPlanUnidad: this.number(0),
            // map
            nombre: this.string(''),
            cod: this.string(''),
            selected: this.boolean(true),
            // unitplan
            uniplant: this.belongsTo(UnitPlan, 'idPlanUnidad'),
        };
    }
}
